var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import databus from './databus';
import { biliBridge } from '@bilibili/js-bridge';
export function protocolReg(url) {
    if (url === void 0) { url = ''; }
    if (url.indexOf('https') == -1) {
        url = url.replace(/(\w+:)?\/\//, 'https://');
    }
    return url;
}
export function getRandomString(l) {
    var n = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    var e = '';
    for (var g = 0; g < l; g += 1) {
        var h = Math.floor(62 * Math.random());
        e += n[h];
    }
    return e;
}
export function getScript(url, callback, options) {
    if (url === void 0) { url = ''; }
    if (options === void 0) { options = {}; }
    var script = document.createElement('script');
    if (typeof callback === 'function') {
        script.onload = callback;
    }
    script.id = options.id || '';
    script.src = url;
    document.body.appendChild(script);
}
export function getJsonp(url, data, callback) {
    var jsonpKey = 'jsonpCallback_' + getRandomString(20);
    var formatParam = generateQueryString(__assign(__assign({}, data), { callback: jsonpKey }));
    window[jsonpKey] = function (res) {
        console.log('jsonpKey: ', jsonpKey);
        callback && callback(res);
        window[jsonpKey] = null;
        var getKeyDom = document.getElementById(jsonpKey);
        if (getKeyDom) {
            document.body.removeChild(getKeyDom);
        }
    };
    var getUrl = "" + url + (url.indexOf('?') >= 0 ? '&' : '?') + formatParam;
    getScript(getUrl, undefined, {
        id: jsonpKey
    });
}
export function getList(key, shareChannelQueue) {
    var channels;
    if (shareChannelQueue) {
        var keyMap_1 = {
            'qq': 'qq',
            'q_zone': 'qzone',
            'weixin': 'weixin',
            'sina': 'weibo',
            'weixin_monment': 'weixin_moment',
            'dynamic': 'bili',
            'copy': 'copy_link',
            'generic': 'more',
        };
        channels = shareChannelQueue.map(function (channelName) {
            return databus.channel.find(function (item) { return item.name === keyMap_1[channelName]; });
        });
        var tieba = databus.channel.find(function (item) { return item.name === 'baidu_tieba'; });
        channels.push(tieba);
    }
    else {
        channels = databus.channel;
    }
    return channels.filter(function (item) { return item[key]; });
}
export function getItem(name) {
    var item = databus.channel.filter(function (obj) { return obj.name === name; });
    return item.length > 0 ? item[0] : {};
}
export function setChannelKey(url, type, noBbid) {
    if (noBbid === void 0) { noBbid = false; }
    var hashSplit = url.split('#');
    var hash = hashSplit[1] ? "#" + hashSplit[1] : '';
    var searchSplit = (hashSplit[0] || '').split('?');
    var query = (searchSplit[1] || '').split('&');
    var shareQuery = __assign(__assign({}, arrtoObj(query)), { share_source: type, share_medium: getMedium(), bbid: noBbid ? '' : (getCookie('buvid3') || ''), ts: new Date().getTime() });
    var paramStr = generateQueryString(shareQuery);
    return searchSplit[0] + "?" + paramStr + hash;
}
export function generateQueryString(obj) {
    return Object.keys(obj)
        .map(function (key) { return key + "=" + encodeURIComponent(obj[key] || ''); })
        .join('&');
}
export function getCookie(name) {
    var arr = [];
    var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    if ((arr = document.cookie.match(reg)))
        return unescape(arr[2]);
    else
        return null;
}
export function getObjectPath(obj, path) {
    var pathArr = path.split('.');
    var keyName = '';
    var newObj = obj;
    while (newObj && pathArr.length > 0) {
        keyName = pathArr.shift();
        newObj = newObj[keyName];
    }
    return newObj;
}
export function formatShare(share) {
    var shareConfig = databus.shareConfig;
    var title = share.title, desc = share.desc, link = share.link, pics = share.pics, type = share.type;
    var base = {
        title: title || shareConfig.title,
        desc: desc || shareConfig.desc,
        link: link || shareConfig.link,
        pics: pics || shareConfig.pics,
        type: type || shareConfig.type
    };
    var formattedConfig = __assign(__assign({}, shareConfig), share);
    var channels = ['weibo', 'qzone', 'qq', 'baidu_tieba', 'bili', 'weixin', 'weixin_moment'];
    channels.forEach(function (channelName) {
        formattedConfig[channelName] = __assign(__assign({}, formatAddr(base)), formatAddr(formattedConfig[channelName]));
    });
    return formattedConfig;
}
function formatAddr(share) {
    if (share === void 0) { share = {}; }
    if (share.link && /bilibili\.com/.test(share.link)) {
        share.link = protocolReg(share.link);
    }
    if (share.pics) {
        share.pics = protocolReg(share.pics);
    }
    return share;
}
export function getVersion(rel) {
    var matchVersion = window.navigator.appVersion.match(rel);
    return matchVersion ? matchVersion[1] : 0;
}
export function setSize(font) {
    if (font === void 0) { font = 100; }
    var result = '';
    var doc = document.documentElement;
    var uiWidth = 750;
    var bili = uiWidth / font;
    var screenWidth = doc.offsetWidth;
    if (screenWidth >= uiWidth) {
        result = font + "px";
    }
    else if (screenWidth <= 320) {
        result = 320 / bili + "px";
    }
    else {
        result = screenWidth / bili + "px";
    }
    return result;
}
export function createDiv(html, style, container) {
    var div = document.createElement('div');
    div.innerHTML = html;
    for (var key in style) {
        div.style[key] = style[key];
    }
    if (container) {
        container.appendChild(div);
        return;
    }
    document.body.appendChild(div);
}
export function dialogAddClass($el, name) {
    if ($el.className.indexOf(name) > -1)
        return;
    return ($el.className = $el.className + ' ' + name);
}
export function dialogDeleteClass($el, name) {
    return ($el.className = $el.className.replace(" " + name, ''));
}
export function deleteDOM($el, ts) {
    setTimeout(function () {
        $el &&
            $el.parentNode &&
            $el.parentNode.parentNode &&
            $el.parentNode.parentNode.removeChild($el.parentNode);
    }, ts);
}
export function showWarning(warns) {
    var toast = document.getElementsByClassName('center-toast')[0];
    if (!toast) {
        var html = "\n      <div class=\"center-toast\">\n        <div class=\"info\">" + warns + "</div>\n      </div>\n    ";
        var div = document.createElement('div');
        div.innerHTML = html;
        document.body.appendChild(div);
        toast = document.getElementsByClassName('center-toast')[0];
        deleteDOM(toast, 2000);
    }
}
export function openAppByScheme(scheme) {
    if (databus.browser.isIos) {
        window.location.href = scheme;
    }
    else {
        var iframe_1 = document.createElement('iframe');
        iframe_1.style.display = 'none';
        iframe_1.src = scheme;
        document.body.appendChild(iframe_1);
        setTimeout(function () {
            iframe_1 && iframe_1.parentNode && iframe_1.parentNode.removeChild(iframe_1);
        }, 2000);
    }
}
function arrtoObj(arr) {
    var obj = new Object();
    if (arr.length == 1 && arr[0] == '') {
        return {};
    }
    else {
        for (var x in arr) {
            var split = arr[x].split('=');
            obj[split[0]] = split[1];
        }
        return obj;
    }
}
function getMedium() {
    if (databus.browser.isIphone) {
        return 'iphone';
    }
    else if (databus.browser.isIpad) {
        return 'ipad';
    }
    else if (databus.browser.isAndroid) {
        return 'android';
    }
    else {
        return 'h5';
    }
}
export function preloadImages(srcArr) {
    var loadImage = function (src) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                resolve(img);
            };
            img.onerror = function (err) {
                reject(err);
            };
            img.src = src;
        });
    };
    return Promise.all(srcArr.map(loadImage));
}
export function jumpLogin() {
    if (databus.browser.isBiliApp) {
        try {
            biliBridge.callNative({
                method: 'auth.login',
                data: {
                    type: 'default',
                    callbackUrl: window.location.href,
                },
            });
        }
        catch (err) {
            showWarning(err.message || err.msg);
        }
    }
    else {
        window.location.href =
            'https://passport.bilibili.com/login?gourl=' + window.location.href;
    }
}
